<div class="mat-chip-list-wrapper"><ng-content></ng-content></div>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/chips/typings/index.d.ts.MatChipList.html